import Vue from 'vue';
import FmlNavBar from './fmlNavBar';
const components = [FmlNavBar];
components.forEach((component: any) => {
  Vue.component(component.options.name, component);
});
